import script from "./SchemeMethods.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemeMethods.vue?vue&type=script&setup=true&lang=js"

import "./SchemeMethods.vue?vue&type=style&index=0&id=0bd21fc8&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bd21fc8"]])

export default __exports__